// extracted by css-extract-rspack-plugin
export default {"container":"EventSessionLogs-module__container__YsGe9","turn":"EventSessionLogs-module__turn__HFjmw"};